export default __webpack_public_path__ + "static/media/gaetan.0a649cae.jpg";